//#region src/order_channel.ts
var OrderChannel = /* @__PURE__ */ function(OrderChannel) {
	OrderChannel["DriveThru"] = "drive-thru";
	OrderChannel["Flash"] = "flash";
	OrderChannel["Kiosk"] = "kiosk";
	OrderChannel["Linebuster"] = "linebuster";
	OrderChannel["Web"] = "web";
	return OrderChannel;
}(OrderChannel || {});
//#endregion
export { OrderChannel };

//# sourceMappingURL=order_channel.js.map